// WHERE THE DOORS ARE, for anything that must never stand in front of one
// (SolidClamp's walls, 2026-11-01). Portals publishes `near` — its own trigger
// test (components/Portals toPortalLocal), each box widened by a margin — over
// the doors of the zone you are in. null = no doors known yet.
//   doorZones.near(wx, wy, wz, margin?) → true when that world point is in or
//   beside a door's trigger.
export const doorZones = { near: null };
